import { render } from "./svg-coupon.vue?vue&type=template&id=786880b7"
import script from "./svg-coupon.vue?vue&type=script&lang=ts"
export * from "./svg-coupon.vue?vue&type=script&lang=ts"
script.render = render

export default script